var map = {
	"./Grade1/2023/premium300/Elementary Word List 2023.json": 295,
	"./Grade1/2024/premium300/AI Generated Complex Elementary Word List 2024.json": 296,
	"./Grade1/2024/premium300/Elementary Word List 2024 with hyphens and spaces.json": 297,
	"./Grade1/2024/premium300/Elementary Word List 2024 with hyphens.json": 298,
	"./Grade1/2024/premium300/Elementary Word List 2024 with spaces.json": 299,
	"./Grade1/2024/premium300/Elementary Word List 2024 with upper cases.json": 300,
	"./Grade1/2024/premium300/Elementary Word List 2024.json": 301,
	"./Grade10/2023/premium300/Senior Word List 2023.json": 302,
	"./Grade10/2024/premium300/AI Generated Complex Senior Word List 2024.json": 303,
	"./Grade10/2024/premium300/Senior Word List 2024 with hyphens and spaces.json": 304,
	"./Grade10/2024/premium300/Senior Word List 2024 with hyphens.json": 305,
	"./Grade10/2024/premium300/Senior Word List 2024 with spaces.json": 306,
	"./Grade10/2024/premium300/Senior Word List 2024 with upper cases.json": 307,
	"./Grade10/2024/premium300/Senior Word List 2024.json": 308,
	"./Grade10/2025/premium1000/Senior Word List 2025.json": 309,
	"./Grade10/2025/premium1000/Senior Word List 2025.json with hyphens and spaces.json": 310,
	"./Grade10/2025/premium1000/Senior Word List 2025.json with upper cases.json": 311,
	"./Grade10/2025/premium1000/Senior Word List 2025_filtered.json": 312,
	"./Grade10/2026/premium0/Senior Word List 2026.json": 313,
	"./Grade10/2026/premium0/Senior Word List 2026.json with hyphens and spaces.json": 314,
	"./Grade10/2026/premium0/Senior Word List 2026.json with upper cases.json": 315,
	"./Grade11/2023/premium300/Senior Word List 2023.json": 316,
	"./Grade11/2024/premium300/AI Generated Complex Senior Word List 2024.json": 317,
	"./Grade11/2024/premium300/Senior Word List 2024 with hyphens and spaces.json": 318,
	"./Grade11/2024/premium300/Senior Word List 2024 with hyphens.json": 319,
	"./Grade11/2024/premium300/Senior Word List 2024 with spaces.json": 320,
	"./Grade11/2024/premium300/Senior Word List 2024 with upper cases.json": 321,
	"./Grade11/2024/premium300/Senior Word List 2024.json": 322,
	"./Grade11/2025/premium1000/Senior Word List 2025.json": 323,
	"./Grade11/2025/premium1000/Senior Word List 2025.json with hyphens and spaces.json": 324,
	"./Grade11/2025/premium1000/Senior Word List 2025.json with upper cases.json": 325,
	"./Grade11/2025/premium1000/Senior Word List 2025_filtered.json": 326,
	"./Grade11/2026/premium0/Senior Word List 2026.json": 327,
	"./Grade11/2026/premium0/Senior Word List 2026.json with hyphens and spaces.json": 328,
	"./Grade11/2026/premium0/Senior Word List 2026.json with upper cases.json": 329,
	"./Grade12/2021/premium300/SpellBowl0.json": 330,
	"./Grade12/2021/premium300/SpellBowl01.json": 331,
	"./Grade12/2021/premium300/SpellBowl100.json": 332,
	"./Grade12/2021/premium300/SpellBowl150.json": 333,
	"./Grade12/2021/premium300/SpellBowl200.json": 334,
	"./Grade12/2021/premium300/SpellBowl250.json": 335,
	"./Grade12/2021/premium300/SpellBowl300.json": 336,
	"./Grade12/2021/premium300/SpellBowl350.json": 337,
	"./Grade12/2021/premium300/SpellBowl400.json": 338,
	"./Grade12/2021/premium300/SpellBowl450.json": 339,
	"./Grade12/2021/premium300/SpellBowl50.json": 340,
	"./Grade12/2021/premium300/SpellBowl500.json": 341,
	"./Grade12/2021/premium300/SpellBowl550.json": 342,
	"./Grade12/2021/premium300/SpellBowl600.json": 343,
	"./Grade12/2021/premium300/SpellBowl650.json": 344,
	"./Grade12/2021/premium300/SpellBowl700.json": 345,
	"./Grade12/2022/premium300/Spell_Bowl_Elementary_2022_with_meanings.json": 346,
	"./Grade12/2022/premium300/spellbowlelementary_2022_100.json": 347,
	"./Grade12/2022/premium300/spellbowlelementary_2022_150.json": 348,
	"./Grade12/2022/premium300/spellbowlelementary_2022_200.json": 349,
	"./Grade12/2022/premium300/spellbowlelementary_2022_250.json": 350,
	"./Grade12/2022/premium300/spellbowlelementary_2022_300.json": 351,
	"./Grade12/2022/premium300/spellbowlelementary_2022_350.json": 352,
	"./Grade12/2022/premium300/spellbowlelementary_2022_400.json": 353,
	"./Grade12/2022/premium300/spellbowlelementary_2022_450.json": 354,
	"./Grade12/2022/premium300/spellbowlelementary_2022_50.json": 355,
	"./Grade12/2022/premium300/spellbowlelementary_2022_500.json": 356,
	"./Grade12/2022/premium300/spellbowlelementary_2022_550.json": 357,
	"./Grade12/2022/premium300/spellbowlelementary_2022_600.json": 358,
	"./Grade12/2022/premium300/spellbowlelementary_2022_650.json": 359,
	"./Grade12/2022/premium300/spellbowlelementary_2022_700.json": 360,
	"./Grade12/2022/premium300/spellbowlelementary_2022_750.json": 361,
	"./Grade12/2023/premium300/Senior Word List 2023.json": 362,
	"./Grade12/2024/premium300/AI Generated Complex Senior Word List 2024.json": 363,
	"./Grade12/2024/premium300/Senior Word List 2024 with hyphens and spaces.json": 364,
	"./Grade12/2024/premium300/Senior Word List 2024 with hyphens.json": 365,
	"./Grade12/2024/premium300/Senior Word List 2024 with spaces.json": 366,
	"./Grade12/2024/premium300/Senior Word List 2024 with upper cases.json": 367,
	"./Grade12/2024/premium300/Senior Word List 2024.json": 368,
	"./Grade12/2025/premium1000/Senior Word List 2025.json": 369,
	"./Grade12/2025/premium1000/Senior Word List 2025.json with hyphens and spaces.json": 370,
	"./Grade12/2025/premium1000/Senior Word List 2025.json with upper cases.json": 371,
	"./Grade12/2025/premium1000/Senior Word List 2025_filtered.json": 372,
	"./Grade12/2026/premium0/Senior Word List 2026.json": 373,
	"./Grade12/2026/premium0/Senior Word List 2026.json with hyphens and spaces.json": 374,
	"./Grade12/2026/premium0/Senior Word List 2026.json with upper cases.json": 375,
	"./Grade4/2023/premium300/Elementary Word List 2023.json": 376,
	"./Grade4/2024/premium300/AI Generated Complex Elementary Word List 2024.json": 377,
	"./Grade4/2024/premium300/Elementary Word List 2024 with hyphens and spaces.json": 378,
	"./Grade4/2024/premium300/Elementary Word List 2024 with hyphens.json": 379,
	"./Grade4/2024/premium300/Elementary Word List 2024 with spaces.json": 380,
	"./Grade4/2024/premium300/Elementary Word List 2024 with upper cases.json": 381,
	"./Grade4/2024/premium300/Elementary Word List 2024.json": 382,
	"./Grade4/2025/premium10000/Elementary Word List 2025.json": 383,
	"./Grade4/2025/premium10000/Elementary Word List 2025.json with hyphens and spaces.json": 384,
	"./Grade4/2025/premium10000/Elementary Word List 2025.json with upper cases.json": 385,
	"./Grade4/2025/premium10000/Elementary Word List 2025_filtered.json": 386,
	"./Grade4/2026/premium0/Elementary Word List 2026.json": 387,
	"./Grade4/2026/premium0/Elementary Word List 2026.json with hyphens and spaces.json": 388,
	"./Grade4/2026/premium0/Elementary Word List 2026.json with upper cases.json": 389,
	"./Grade5/2021/premium300/SpellBowl0.json": 390,
	"./Grade5/2021/premium300/SpellBowl01.json": 391,
	"./Grade5/2021/premium300/SpellBowl100.json": 392,
	"./Grade5/2021/premium300/SpellBowl150.json": 393,
	"./Grade5/2021/premium300/SpellBowl200.json": 394,
	"./Grade5/2021/premium300/SpellBowl250.json": 395,
	"./Grade5/2021/premium300/SpellBowl300.json": 396,
	"./Grade5/2021/premium300/SpellBowl350.json": 397,
	"./Grade5/2021/premium300/SpellBowl400.json": 398,
	"./Grade5/2021/premium300/SpellBowl450.json": 399,
	"./Grade5/2021/premium300/SpellBowl50.json": 400,
	"./Grade5/2021/premium300/SpellBowl500.json": 401,
	"./Grade5/2021/premium300/SpellBowl550.json": 402,
	"./Grade5/2021/premium300/SpellBowl600.json": 403,
	"./Grade5/2021/premium300/SpellBowl650.json": 404,
	"./Grade5/2021/premium300/SpellBowl700.json": 405,
	"./Grade5/2021/premium3000/SpellBowl0.json": 406,
	"./Grade5/2021/premium3000/SpellBowl01.json": 407,
	"./Grade5/2021/premium3000/SpellBowl100.json": 408,
	"./Grade5/2021/premium3000/SpellBowl150.json": 409,
	"./Grade5/2021/premium3000/SpellBowl200.json": 410,
	"./Grade5/2021/premium3000/SpellBowl250.json": 411,
	"./Grade5/2021/premium3000/SpellBowl300.json": 412,
	"./Grade5/2021/premium3000/SpellBowl350.json": 413,
	"./Grade5/2021/premium3000/SpellBowl400.json": 414,
	"./Grade5/2021/premium3000/SpellBowl450.json": 415,
	"./Grade5/2021/premium3000/SpellBowl50.json": 416,
	"./Grade5/2021/premium3000/SpellBowl500.json": 417,
	"./Grade5/2021/premium3000/SpellBowl550.json": 418,
	"./Grade5/2021/premium3000/SpellBowl600.json": 419,
	"./Grade5/2021/premium3000/SpellBowl650.json": 420,
	"./Grade5/2021/premium3000/SpellBowl700.json": 421,
	"./Grade5/2022/premium300/Spell_Bowl_Elementary_2022_with_meanings.json": 422,
	"./Grade5/2022/premium300/spellbowlelementary_2022_100.json": 423,
	"./Grade5/2022/premium300/spellbowlelementary_2022_150.json": 424,
	"./Grade5/2022/premium300/spellbowlelementary_2022_200.json": 425,
	"./Grade5/2022/premium300/spellbowlelementary_2022_250.json": 426,
	"./Grade5/2022/premium300/spellbowlelementary_2022_300.json": 427,
	"./Grade5/2022/premium300/spellbowlelementary_2022_350.json": 428,
	"./Grade5/2022/premium300/spellbowlelementary_2022_400.json": 429,
	"./Grade5/2022/premium300/spellbowlelementary_2022_450.json": 430,
	"./Grade5/2022/premium300/spellbowlelementary_2022_50.json": 431,
	"./Grade5/2022/premium300/spellbowlelementary_2022_500.json": 432,
	"./Grade5/2022/premium300/spellbowlelementary_2022_550.json": 433,
	"./Grade5/2022/premium300/spellbowlelementary_2022_600.json": 434,
	"./Grade5/2022/premium300/spellbowlelementary_2022_650.json": 435,
	"./Grade5/2022/premium300/spellbowlelementary_2022_700.json": 436,
	"./Grade5/2022/premium300/spellbowlelementary_2022_750.json": 437,
	"./Grade5/2022/premium3000/Spell_Bowl_Elementary_2022_with_meanings.json": 438,
	"./Grade5/2022/premium3000/spellbowlelementary_2022_100.json": 439,
	"./Grade5/2022/premium3000/spellbowlelementary_2022_150.json": 440,
	"./Grade5/2022/premium3000/spellbowlelementary_2022_200.json": 441,
	"./Grade5/2022/premium3000/spellbowlelementary_2022_250.json": 442,
	"./Grade5/2022/premium3000/spellbowlelementary_2022_300.json": 443,
	"./Grade5/2022/premium3000/spellbowlelementary_2022_350.json": 444,
	"./Grade5/2022/premium3000/spellbowlelementary_2022_400.json": 445,
	"./Grade5/2022/premium3000/spellbowlelementary_2022_450.json": 446,
	"./Grade5/2022/premium3000/spellbowlelementary_2022_50.json": 447,
	"./Grade5/2022/premium3000/spellbowlelementary_2022_500.json": 448,
	"./Grade5/2022/premium3000/spellbowlelementary_2022_550.json": 449,
	"./Grade5/2022/premium3000/spellbowlelementary_2022_600.json": 450,
	"./Grade5/2022/premium3000/spellbowlelementary_2022_650.json": 451,
	"./Grade5/2022/premium3000/spellbowlelementary_2022_700.json": 452,
	"./Grade5/2022/premium3000/spellbowlelementary_2022_750.json": 453,
	"./Grade5/2023/premium300/Elementary Word List 2023.json": 454,
	"./Grade5/2023/premium3000/Elementary Word List 2023.json": 455,
	"./Grade5/2024/premium500/AI Generated Complex Elementary Word List 2024.json": 456,
	"./Grade5/2024/premium500/Elementary Word List 2024 with hyphens and spaces.json": 457,
	"./Grade5/2024/premium500/Elementary Word List 2024 with hyphens.json": 458,
	"./Grade5/2024/premium500/Elementary Word List 2024 with spaces.json": 459,
	"./Grade5/2024/premium500/Elementary Word List 2024 with upper cases.json": 460,
	"./Grade5/2024/premium500/Elementary Word List 2024.json": 461,
	"./Grade5/2025/premium1000/Elementary Word List 2025 with hyphens and spaces.json": 462,
	"./Grade5/2025/premium1000/Elementary Word List 2025.json": 463,
	"./Grade5/2025/premium1000/Elementary Word List 2025.json with upper cases.json": 464,
	"./Grade5/2025/premium1000/Elementary Word List 2025_filtered.json": 465,
	"./Grade5/2026/premium0/Elementary Word List 2026.json": 466,
	"./Grade5/2026/premium0/Elementary Word List 2026.json with hyphens and spaces.json": 467,
	"./Grade5/2026/premium0/Elementary Word List 2026.json with upper cases.json": 468,
	"./Grade6/2022/premium300/CommonlyMissedJunior.json": 469,
	"./Grade6/2022/premium300/Spell_Bowl_Junior_2022_with_meanings.json": 470,
	"./Grade6/2022/premium300/spellbowljunior_2022_100.json": 471,
	"./Grade6/2022/premium300/spellbowljunior_2022_1000.json": 472,
	"./Grade6/2022/premium300/spellbowljunior_2022_1050.json": 473,
	"./Grade6/2022/premium300/spellbowljunior_2022_1100.json": 474,
	"./Grade6/2022/premium300/spellbowljunior_2022_1150.json": 475,
	"./Grade6/2022/premium300/spellbowljunior_2022_1200.json": 476,
	"./Grade6/2022/premium300/spellbowljunior_2022_1250.json": 477,
	"./Grade6/2022/premium300/spellbowljunior_2022_1300.json": 478,
	"./Grade6/2022/premium300/spellbowljunior_2022_1350.json": 479,
	"./Grade6/2022/premium300/spellbowljunior_2022_1400.json": 480,
	"./Grade6/2022/premium300/spellbowljunior_2022_150.json": 481,
	"./Grade6/2022/premium300/spellbowljunior_2022_200.json": 482,
	"./Grade6/2022/premium300/spellbowljunior_2022_250.json": 483,
	"./Grade6/2022/premium300/spellbowljunior_2022_300.json": 484,
	"./Grade6/2022/premium300/spellbowljunior_2022_350.json": 485,
	"./Grade6/2022/premium300/spellbowljunior_2022_400.json": 486,
	"./Grade6/2022/premium300/spellbowljunior_2022_450.json": 487,
	"./Grade6/2022/premium300/spellbowljunior_2022_50.json": 488,
	"./Grade6/2022/premium300/spellbowljunior_2022_500.json": 489,
	"./Grade6/2022/premium300/spellbowljunior_2022_550.json": 490,
	"./Grade6/2022/premium300/spellbowljunior_2022_600.json": 491,
	"./Grade6/2022/premium300/spellbowljunior_2022_650.json": 492,
	"./Grade6/2022/premium300/spellbowljunior_2022_700.json": 493,
	"./Grade6/2022/premium300/spellbowljunior_2022_750.json": 494,
	"./Grade6/2022/premium300/spellbowljunior_2022_800.json": 495,
	"./Grade6/2022/premium300/spellbowljunior_2022_850.json": 496,
	"./Grade6/2022/premium300/spellbowljunior_2022_900.json": 497,
	"./Grade6/2022/premium300/spellbowljunior_2022_950.json": 498,
	"./Grade6/2023/premium300/Junior Word List 2023.json": 499,
	"./Grade6/2024/premium300/AI Generated Complex Junior Word List 2024.json": 500,
	"./Grade6/2024/premium300/Junior Word List 2024 with hyphens and spaces.json": 501,
	"./Grade6/2024/premium300/Junior Word List 2024 with hyphens.json": 502,
	"./Grade6/2024/premium300/Junior Word List 2024 with spaces.json": 503,
	"./Grade6/2024/premium300/Junior Word List 2024 with upper cases.json": 504,
	"./Grade6/2024/premium300/Junior Word List 2024.json": 505,
	"./Grade6/2025/premium1000/Junior Word List 2025.json": 506,
	"./Grade6/2025/premium1000/Junior Word List 2025.json with hyphens and spaces.json": 507,
	"./Grade6/2025/premium1000/Junior Word List 2025.json with upper cases.json": 508,
	"./Grade6/2025/premium1000/Junior Word List 2025_filtered.json": 509,
	"./Grade6/2026/premium0/Junior Word List 2026.json": 510,
	"./Grade6/2026/premium0/Junior Word List 2026.json with hyphens and spaces.json": 511,
	"./Grade6/2026/premium0/Junior Word List 2026.json with upper cases.json": 512,
	"./Grade7/2023/premium200/Junior Word List 2023.json": 513,
	"./Grade7/2023/premium300/Junior Word List 2023_both.json": 514,
	"./Grade7/2023/premium300/Junior Word List 2023_hyphen.json": 515,
	"./Grade7/2023/premium300/Junior Word List 2023_space.json": 516,
	"./Grade7/2024/premium200/AI Generated Complex Junior Word List 2024.json": 517,
	"./Grade7/2024/premium200/Junior Word List 2024 with hyphens and spaces.json": 518,
	"./Grade7/2024/premium200/Junior Word List 2024 with hyphens.json": 519,
	"./Grade7/2024/premium200/Junior Word List 2024 with spaces.json": 520,
	"./Grade7/2024/premium200/Junior Word List 2024 with upper cases.json": 521,
	"./Grade7/2024/premium200/Junior Word List 2024.json": 522,
	"./Grade7/2025/premium1000/Junior Word List 2025.json": 523,
	"./Grade7/2025/premium1000/Junior Word List 2025.json with hyphens and spaces.json": 524,
	"./Grade7/2025/premium1000/Junior Word List 2025.json with upper cases.json": 525,
	"./Grade7/2025/premium1000/Junior Word List 2025_filtered.json": 526,
	"./Grade7/2026/premium0/Junior Word List 2026.json": 527,
	"./Grade7/2026/premium0/Junior Word List 2026.json with hyphens and spaces.json": 528,
	"./Grade7/2026/premium0/Junior Word List 2026.json with upper cases.json": 529,
	"./Grade8/2023/premium300/Junior Word List 2023.json": 530,
	"./Grade8/2024/premium300/AI Generated Complex Junior Word List 2024.json": 531,
	"./Grade8/2024/premium300/Junior Word List 2024 with hyphens and spaces.json": 532,
	"./Grade8/2024/premium300/Junior Word List 2024 with hyphens.json": 533,
	"./Grade8/2024/premium300/Junior Word List 2024 with spaces.json": 534,
	"./Grade8/2024/premium300/Junior Word List 2024 with upper cases.json": 535,
	"./Grade8/2024/premium300/Junior Word List 2024.json": 536,
	"./Grade8/2025/premium0/Junior Word List 2025.json": 537,
	"./Grade8/2025/premium0/Junior Word List 2025.json with hyphens and spaces.json": 538,
	"./Grade8/2025/premium0/Junior Word List 2025.json with upper cases.json": 539,
	"./Grade8/2025/premium0/Junior Word List 2025_filtered.json": 540,
	"./Grade8/2026/premium0/Junior Word List 2026.json": 541,
	"./Grade8/2026/premium0/Junior Word List 2026.json with hyphens and spaces.json": 542,
	"./Grade8/2026/premium0/Junior Word List 2026.json with upper cases.json": 543,
	"./Grade9/2022/premium300/Spell_Bowl_Senior_2022_with_meanings.json": 544,
	"./Grade9/2022/premium300/spellbowlsenior_2022_100.json": 545,
	"./Grade9/2022/premium300/spellbowlsenior_2022_1000.json": 546,
	"./Grade9/2022/premium300/spellbowlsenior_2022_1050.json": 547,
	"./Grade9/2022/premium300/spellbowlsenior_2022_1100.json": 548,
	"./Grade9/2022/premium300/spellbowlsenior_2022_1150.json": 549,
	"./Grade9/2022/premium300/spellbowlsenior_2022_1200.json": 550,
	"./Grade9/2022/premium300/spellbowlsenior_2022_1250.json": 551,
	"./Grade9/2022/premium300/spellbowlsenior_2022_1300.json": 552,
	"./Grade9/2022/premium300/spellbowlsenior_2022_1350.json": 553,
	"./Grade9/2022/premium300/spellbowlsenior_2022_1400.json": 554,
	"./Grade9/2022/premium300/spellbowlsenior_2022_1450.json": 555,
	"./Grade9/2022/premium300/spellbowlsenior_2022_150.json": 556,
	"./Grade9/2022/premium300/spellbowlsenior_2022_1500.json": 557,
	"./Grade9/2022/premium300/spellbowlsenior_2022_1550.json": 558,
	"./Grade9/2022/premium300/spellbowlsenior_2022_1600.json": 559,
	"./Grade9/2022/premium300/spellbowlsenior_2022_1650.json": 560,
	"./Grade9/2022/premium300/spellbowlsenior_2022_1700.json": 561,
	"./Grade9/2022/premium300/spellbowlsenior_2022_1750.json": 562,
	"./Grade9/2022/premium300/spellbowlsenior_2022_1800.json": 563,
	"./Grade9/2022/premium300/spellbowlsenior_2022_1850.json": 564,
	"./Grade9/2022/premium300/spellbowlsenior_2022_1900.json": 565,
	"./Grade9/2022/premium300/spellbowlsenior_2022_1950.json": 566,
	"./Grade9/2022/premium300/spellbowlsenior_2022_200.json": 567,
	"./Grade9/2022/premium300/spellbowlsenior_2022_2000.json": 568,
	"./Grade9/2022/premium300/spellbowlsenior_2022_2050.json": 569,
	"./Grade9/2022/premium300/spellbowlsenior_2022_2100.json": 570,
	"./Grade9/2022/premium300/spellbowlsenior_2022_2150.json": 571,
	"./Grade9/2022/premium300/spellbowlsenior_2022_2200.json": 572,
	"./Grade9/2022/premium300/spellbowlsenior_2022_250.json": 573,
	"./Grade9/2022/premium300/spellbowlsenior_2022_300.json": 574,
	"./Grade9/2022/premium300/spellbowlsenior_2022_350.json": 575,
	"./Grade9/2022/premium300/spellbowlsenior_2022_400.json": 576,
	"./Grade9/2022/premium300/spellbowlsenior_2022_450.json": 577,
	"./Grade9/2022/premium300/spellbowlsenior_2022_50.json": 578,
	"./Grade9/2022/premium300/spellbowlsenior_2022_500.json": 579,
	"./Grade9/2022/premium300/spellbowlsenior_2022_550.json": 580,
	"./Grade9/2022/premium300/spellbowlsenior_2022_600.json": 581,
	"./Grade9/2022/premium300/spellbowlsenior_2022_650.json": 582,
	"./Grade9/2022/premium300/spellbowlsenior_2022_700.json": 583,
	"./Grade9/2022/premium300/spellbowlsenior_2022_750.json": 584,
	"./Grade9/2022/premium300/spellbowlsenior_2022_800.json": 585,
	"./Grade9/2022/premium300/spellbowlsenior_2022_850.json": 586,
	"./Grade9/2022/premium300/spellbowlsenior_2022_900.json": 587,
	"./Grade9/2022/premium300/spellbowlsenior_2022_950.json": 588,
	"./Grade9/2023/premium300/Senior Word List 2023.json": 589,
	"./Grade9/2024/premium300/AI Generated Complex Senior Word List 2024.json": 590,
	"./Grade9/2024/premium300/Senior Word List 2024 with hyphens and spaces.json": 591,
	"./Grade9/2024/premium300/Senior Word List 2024 with hyphens.json": 592,
	"./Grade9/2024/premium300/Senior Word List 2024 with spaces.json": 593,
	"./Grade9/2024/premium300/Senior Word List 2024 with upper cases.json": 594,
	"./Grade9/2024/premium300/Senior Word List 2024.json": 595,
	"./Grade9/2025/premium1000/Senior Word List 2025 with hyphens and spaces.json": 596,
	"./Grade9/2025/premium1000/Senior Word List 2025 with upper cases.json": 597,
	"./Grade9/2025/premium1000/Senior Word List 2025.json": 598,
	"./Grade9/2025/premium1000/Senior Word List 2025_filtered.json": 599,
	"./Grade9/2026/premium0/Senior Word List 2026.json": 600,
	"./Grade9/2026/premium0/Senior Word List 2026.json with hyphens and spaces.json": 601,
	"./Grade9/2026/premium0/Senior Word List 2026.json with upper cases.json": 602
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 636;